import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { core_features, lean_features } from 'src/@smartmanufacturing/common/custom_methods';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { AnalyticalToolsService } from 'src/app/services/analytical-tools.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TranslaterService } from 'src/app/services/translater.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/components/custom-validators';
import { LoggedUser } from 'src/backend/models/session-users/session-users';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrivateLayoutComponent } from 'src/app/shared/private-layout/private-layout.component';
import { BaseApi } from 'src/backend/api/base-api';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import * as CryptoJS from 'crypto-js';
import { getChildHierarchy, getImmediateChildren, getParentHierarchy } from 'src/@smartmanufacturing/common/custom_methods';
import { DynamicDashboardService } from 'src/app/services/dynamic-dashboard.service';
import { MenuItem } from 'primeng/api';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  leftBannerImgurl = 'assets/images/login-banner.png';
  homeCardList: any[] = [];
  breadcrumList: any[] = [];
  userName!: any;
  selectedRowIndex = -1;
  CrewId!: any;
  languageDir = 'ltr';
  user!: LoggedUser;
  langObject: any = {};
  resetPasswordForm!: FormGroup;
  //temporarily marked as true
  shiftStartDataSource!: MatTableDataSource<any>;
  minimumLength: any;
  isDisabled: boolean = true;
  shiftDialogRef: MatDialogRef<any, any>;
  resetDialogRef: MatDialogRef<any, any>;
  navbarcom: PrivateLayoutComponent;
  searchValue: any;
  menus: any[] = [];
  currentMenuId: string = '';
  key = CryptoJS.enc.Utf8.parse(Constants.HASH_KEY);
  iv = CryptoJS.enc.Utf8.parse(Constants.HASH_IV);
  shiftcloseColumns: any[] = [
    'date',
    'shiftstart',
    'shiftend',
    'shift',
    'machine',
  ];
  // @ViewChild('displayShiftStartModal') private displayShiftStartModal!: TemplateRef<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('resetModalContent') private resetModel!: TemplateRef<any>;
  items: MenuItem[] | undefined;
  constructor(
    public router: Router,
    private userManagementService: UserManagementService,
    private toaster: ToastrService,
    private dialog: MatDialog,
    private analyticalToolsService: AnalyticalToolsService,
    public translate: TranslateService,
    public translater: TranslaterService,
    private baseApi: BaseApi,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService, private dyService: DynamicDashboardService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang === 'ar') {
        this.languageDir = 'rtl';
        this.getLangWords();
      } else if (event.lang === 'en') {
        this.languageDir = 'ltr';
        this.getLangWords();
      } else if (event.lang === 'fr') {
        this.languageDir = 'ltr';
        this.getLangWords();
      } else if (event.lang === 'sp') {
        this.languageDir = 'ltr';
        this.getLangWords();
      }
    });
  }

  ngOnInit(): void {
    this.getLangWords();
    this.user = this.baseApi.getUserSession();
    this.resetPasswordForm = this.formBuilder.group(
      {
        oldPassword: ['', Validators.required],
        Password: ['', Validators.required],
        confirmpassword: ['', Validators.compose([Validators.required])],
      },
      { validator: CustomValidators.passwordMatchValidator }
    );
    this.userName = this.baseApi.getUserSession().fullName;
    this.menus = this.baseApi.getMenuCardsSession();
    this.currentMenuId = this.baseApi.getCurrentMenuID();
    // this.GetShiftStart();
    this.getMenuCards();
    this.items = [
      { label: 'Pin to favorite', icon: 'fa fa-thumb-tack' }
    ];
  }
  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : this.translate.currentLang === 'gr'
                  ? 5
                  : this.translate.currentLang === 'du'
                    ? 6
                    : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      this.langObject = res.tagList;
    });
  }

  // database tag -> i18n json -> the tag name itself, so a menu card is never blank
  getTransalatedValue(value: string): string {
    if (!value) {
      return '';
    }

    const tag = this.langObject?.length
      ? this.langObject.find((f: any) => f.tagName === value)
      : null;

    const fromDb = tag?.translatedValue;
    if (fromDb && fromDb.trim()) {
      return fromDb;
    }

    const fromJson = this.translate.instant(value);
    if (typeof fromJson === 'string' && fromJson.trim() && fromJson !== value) {
      return fromJson;
    }

    return value;
  }

  closeResetModal(): void {
    this.isDisabled = true;
    this.resetPasswordForm.get('oldPassword').setValue('');
    this.resetDialogRef.close();
  }

  openResetModal(): void {
    this.resetForm();
    this.resetDialogRef = this.dialog.open(this.resetModel, {
      height: 'auto',
      width: '40%',
      disableClose: true,
    });
  }

  resetForm() {
    this.resetPasswordForm.get('Password').setValue('');
    this.resetPasswordForm.get('confirmpassword').setValue('');
  }

  displayRightmenu(menuId: any, url: any, type: string, cardItem): any {
    // if (core_features.includes(cardItem?.label)) {
    if ((cardItem?.applicationVariant === Constants.CORE_APP_NAME || cardItem?.applicationVariant === Constants.UI_FORM_BUILDER_APP_NAME || cardItem?.applicationVariant === Constants.UTILITY_APP_NAME) && cardItem.type === Constants.MENU_TYPE_LINK) {
      const appURL = this.baseApi.getAppURL(cardItem?.applicationVariant);
      const plantCode: string = this.baseApi.getPlantCodeFromStorage();
      const groupCode: string = this.baseApi.getGroupCodeFromStorage();
      const queryParams = {
        email: this.user?.userName,
        plantCode,
        groupCode,
        menuId: cardItem?.menuId,
        languageName: localStorage.getItem('Language_Name'),
        token: this.baseApi.getTokenFromStorage(),
      };
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(queryParams),
        this.key,
        { iv: this.iv }
      );
      this.openUrlWithParameters(appURL, {
        encrypted: encrypted.toString(),
      });
    } else if (lean_features.includes(cardItem?.label)) {
      this.baseApi.saveCurrentMenuID(cardItem?.menuId);
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['Home']));
    } else {
      this.baseApi.saveCurrentMenuID(menuId);
      switch (type) {
        case 'subheading':
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['Home']));
          break;
        case 'dropdown':
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['Home']));
          break;
        case 'link':
          if (url.indexOf('/Home/ExternalLink?link=') > -1) {
            url = url.replace('/Home/ExternalLink?link=', '');
            window.open(url, '_blank');
          }
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate([url]));
          break;
        default:
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['Home']));
          break;
      }
    }
  }
  getMenuCards(): any {
    if (!this.currentMenuId || this.currentMenuId == '') {
      this.homeCardList = this.baseApi.getUserMenusSession();
    } else {
      const menuCards = getImmediateChildren(this.menus, this.currentMenuId);
      this.homeCardList = [...menuCards];
    }
    //this.homeCardList = this.menus;
  }

  // GetShiftStart(): void {
  //   const key = {};

  //   this.userManagementService.GetShiftStart(key).subscribe((res: any) => {
  //     this.shiftStartDataSource = new MatTableDataSource<any>(res.CrewsList);
  //     this.getPaginator(this.shiftStartDataSource, 0);
  //     if (res.IsShiftStart === true || res.CrewsList.length === 0) {
  //       //this.dialog.closeAll();
  //       this.shiftDialogRef?.close();
  //     } else {
  //       this.shiftDialogRef = this.dialog.open(this.displayShiftStartModal, {
  //         width: '100vw !important',
  //         height: '90vh',
  //         minWidth: '100vw',
  //         disableClose: true,
  //       });
  //     }
  //   });
  // }

  highlightedRow(element: any): void {
    this.CrewId = element.CrewId;
    this.selectedRowIndex = element.CrewId;
  }

  SubmitShiftStart(): void {
    const key = {
      CrewId: this.CrewId,
    };
    this.userManagementService
      .SubmitShiftStart(key)
      .subscribe((response: any) => {
        if (this.selectedRowIndex === this.CrewId) {
          if (!response.HasError) {
            if (response.ErrorMessage.substring(2, 1) === '0') {
              this.showPopupMsg(response.ErrorMessage);
              this.dialog.closeAll();
            } else {
              this.showPopupMsg(response.ErrorMessage);
            }
          }
          // this.showPopupMsg(res.ErrorMessage);
          // console.log(res.ErrorMessage);
          // this.dialog.closeAll();
        } else {
          this.toaster.error('Error', 'Please select shift start');
        }
      });
  }

  getPaginator(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      data.paginator = this.paginator.toArray()[index];
    }, 1000);
  }

  showPopupMsg(msg: any): any {
    //
    if (msg !== null || msg !== '') {
      if (msg.substring(2, 1) === '0') {
        if (msg === "c0-This Module already exists in your favorite list!") {
          this.toaster.warning('Warning', msg.substring(3, msg.length));
        } else {
          this.toaster.success('Success', msg.substring(3, msg.length));
        }
      } else {
        this.toaster.error('Error', msg.substring(3, msg.length));
      }
    }
  }

  setRca() {
    this.analyticalToolsService.setRca(true);
  }
  openUrlWithParameters(
    url: string,
    parameters: { [key: string]: string }
  ): void {
    const queryString = Object.keys(parameters)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(parameters[key])}`
      )
      .join('&');
    const urlWithParameters = `${url}?${queryString}`;
    window.open(urlWithParameters, '_self');
  }

  makeItFavorite(cardData): void {
    const obj = {
      TransactionType: 1,
      Id: 0,
      menuId: cardData.menuId,
      url: cardData.route,
      menuName: cardData.label,
      order: 0
    };
    this.dyService.saveFavorite(obj).subscribe((res: any) => {
      this.showPopupMsg(res.ErrorMessage);
    });
  }
}
